import { motion } from '@carbon/motion';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { getTitleStyle } from '../../../content/texts/bou-title/title-style';
import { StyledExternalInlineLink } from '../../../content/texts/inline-link';
import { BouColor } from '../../../global/bou-colors';
import { MotionDuration, MotionName, MotionMode } from '../../../motion/types';

export const MenuRoot = styled.div`
  .bm-burger-button {
    button {
      display: none;
    }
  }
  .bm-menu-wrap {
    top: 0px;
    transition: all ${MotionDuration.MODERATE2_240ms}ms ${motion(MotionName.ENTRANCE, MotionMode.PRODUCTIVE)} !important;
  }
`;

export const BurgerIconWrap = styled.div`
  cursor: pointer;
  button {
    display: none !important;
  }
`;

export const ContentRoot = styled.div`
  background-color: ${BouColor.PLATFORM_BG_BLACK};
  min-height: 100%;
  padding-bottom: 40px;
  width: 100%;
  position: relative;
`;

export const ContentMain = styled.div`
  padding: 24px;
`;

export const MenuTitleLarge = styled.h4`
  ${getTitleStyle({ size: 'h4' })}
`;

export const MenuTitleSmall = styled.h5`
  ${getTitleStyle({ size: 'h6' })}
  margin-bottom: 16px;
`;

export const MenuTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CloseButtonWrap = styled.div``;

const commonItemStyle = css`
  color: ${BouColor.PLATFORM_TEXT_WHITE};
  font-size: 14px;
  font-weight: 600;
  line-height: 120%;
  & + & {
    margin-top: 16px;
  }
`;
export const Item = styled.div`
  ${commonItemStyle}
  a {
    text-decoration: none;
    &:hover,
    &:active,
    &:visited {
      color: ${BouColor.PLATFORM_TEXT_WHITE};
    }
  }
`;

export const ItemLink = styled(Link)`
  ${commonItemStyle};
  text-decoration: none;
  &:hover,
  &:active,
  &:visited {
    color: ${BouColor.PLATFORM_TEXT_WHITE};
  }
`;

export const ItemExternalLink = styled.a`
  ${commonItemStyle};
  text-decoration: none;
  &:hover,
  &:active,
  &:visited {
    color: ${BouColor.PLATFORM_TEXT_WHITE};
  }
`;

export const Section = styled.div`
  & + & {
    border-top: 1px solid ${BouColor.PLATFORM_BORDER_GRAY_DARK};
    margin-top: 16px;
    padding-top: 16px;
  }
`;

export const ExternalLink = styled(StyledExternalInlineLink)`
  font-weight: bold;
`;
